import gql from "graphql-tag";

export const CHANGE_USER_MUTATION = gql`
  mutation changeUser($where: ChangeUserInput!){
    changeUser(where: $where)
  }
`;